import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';

export default function AboutHero() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 120);
    return () => clearTimeout(t);
  }, []);

  return (
    <section className="relative min-h-[82vh] flex items-end overflow-hidden bg-luxury-black">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/89c1d2106c8f19dcbcccb921ff2d6d13.jpg"
          alt="Atlantis HVAC Systems team"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/65 via-black/50 to-black/90" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/40 to-black/20" />
      </div>
      <div className="absolute inset-0 pointer-events-none" style={{ background: 'radial-gradient(ellipse 45% 55% at 15% 65%, rgba(201,169,110,0.11) 0%, transparent 60%)' }} />
      <div className="absolute top-0 left-0 right-0 h-px" style={{ background: 'linear-gradient(90deg, rgba(201,169,110,0.40), rgba(201,169,110,0.15) 55%, transparent)' }} />

      <div className={`relative w-full max-w-[1500px] mx-auto px-6 lg:px-14 pb-20 pt-44 transition-all duration-900 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
        <div className="flex items-center gap-2 mb-7">
          <Link to="/" className="font-caps text-[10px] tracking-[0.2em] uppercase text-white/35 hover:text-luxury-gold/70 transition-colors cursor-pointer whitespace-nowrap">Home</Link>
          <span className="text-white/20 text-xs">/</span>
          <span className="font-caps text-[10px] tracking-[0.2em] uppercase text-luxury-gold/65 whitespace-nowrap">About</span>
        </div>

        <div className="flex items-center gap-3 mb-6">
          <div className="w-8 h-0.5 bg-luxury-gold" />
          <span className="font-caps text-[10px] tracking-[0.3em] uppercase text-luxury-gold/60">Established 2002 &bull; Oakville, ON</span>
        </div>

        <h1 className="font-serif text-5xl sm:text-6xl lg:text-8xl text-white leading-none mb-6 font-semibold">
          Two Decades of<br />
          <em className="not-italic text-luxury-gold">Trusted Service</em>
        </h1>

        <p className="font-sans text-base lg:text-lg text-white/50 leading-relaxed max-w-xl mb-10">
          Founded in 2002, Atlantis HVAC Systems Inc. built its reputation on one principle — honest advice and expert results. T.S.S.A.-certified and proud to serve the GTA.
        </p>

        <div className="flex flex-col sm:flex-row gap-4">
          <a
            href="tel:9058454009"
            className="inline-flex items-center justify-center gap-3 bg-luxury-gold hover:bg-luxury-gold-light text-luxury-black font-caps font-bold text-xs tracking-[0.18em] uppercase px-9 py-4 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap shadow-gold"
          >
            <div className="w-5 h-5 flex items-center justify-center"><i className="ri-phone-fill text-sm" /></div>
            <span>Talk to Our Team</span>
          </a>
          <Link
            to="/services"
            className="inline-flex items-center justify-center gap-3 border border-white/25 hover:border-luxury-gold/60 text-white hover:text-luxury-gold font-caps text-xs tracking-[0.18em] uppercase px-8 py-4 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            <span>Our Services</span>
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}
